<template>
  <div>
    <mt-header title="用户登录">
      <router-link to="/" slot="left">返回</router-link>
    </mt-header>
    <div class="btn-wrap">
      <p class="title">欢迎登录</p>
      <div class="phone-wrap">
        <i class="iconfont icon-shouji2" style="font-size: 0.4rem"></i>
        <input class="ipt" placeholder="请输入手机号" v-model="phone" type="text" />
      </div>
      <div class="code-wrap">
        <div class="code-con">
          <i class="iconfont icon-mima" style="font-size: 0.4rem"></i>
          <input
            class="ipt"
            v-model="password"
            placeholder="请输入密码"
            type="password"
          />
        </div>
      </div>
      <div class="tips-box">
        <div @ class="reg-tip color-tip" @click="linkToBkREG">没有账号，立即注册</div>
        <router-link class="color-tip" to="/changePwd">忘记密码</router-link>
      </div>

      <div @click="loginHandle" class="btn">登录</div>
    </div>
  </div>
</template>

<script>
import { login, checkLogin, reBindingOrg, insInfo, register } from "@/api/api.js";
import { isEmpty, cacheGet, cacheSet, urlSearchObj } from "@/utils/util.js";
import { Toast, Indicator, MessageBox } from "mint-ui";

export default {
  data() {
    return {
      phone: "",
      password: "",
      authCode: "",
      org_id: "",
    };
  },
  mounted() {
    insInfo().then((res) => {
      this.authCode = res.instanceInfo.base.organizationAuthCode;
      this.org_id = res.instanceInfo.orgInfo.orgId;
    });
  },
  methods: {
    linkToBkREG() {
      this.$router.push("bkReg");
    },
    async loginHandle() {
      if (this.checkSave()) {
        try {
          const res = await login({
            phone: this.phone,
            password: this.password,
            org_id: this.org_id,
          });
          const { token, expire, username } = res.data;
          cacheSet("token", token, expire);
          cacheSet("phone", this.phone);
          Toast("登录成功");
          if (isEmpty(username)) {
            setTimeout(() => {
              this.$router.replace("/bindName");
            }, 200);
          } else {
            cacheSet("username", username);
            setTimeout(() => {
              this.$router.replace("/");
            }, 800);
          }
        } catch (err) {
          console.log(err, "errr");
          if (err.code == 1012) {
            // 是博看用户 但不是当前机构下的用户
            MessageBox.confirm("确定切换到该机构?").then((action) => {
              if (action == "confirm") {
                checkLogin({
                  phone: this.phone,
                  password: this.password,
                }).then((res) => {
                  let bk_organizationUserId = res.organizationUserId;
                  let bk_token = res.token;
                  reBindingOrg({
                    organizationUserId: bk_organizationUserId,
                    instanceIdCheck: urlSearchObj().id,
                    authCode: this.authCode,
                    token: bk_token,
                  }).then(async (resBind) => {
                    Toast("切换成功");
                    const res = await login({
                      phone: this.phone,
                      password: this.password,
                      org_id: this.org_id,
                    });
                    const { token, expire, username } = res.data;
                    cacheSet("token", token, expire);
                    cacheSet("phone", this.phone);
                    Toast("登录成功");
                    if (isEmpty(username)) {
                      setTimeout(() => {
                        this.$router.replace("/bindName");
                      }, 200);
                    } else {
                      cacheSet("username", username);
                      setTimeout(() => {
                        this.$router.replace("/");
                      }, 800);
                    }
                  });
                });
              }
            });
          }
        }
      }
    },

    checkSave() {
      if (isEmpty(this.phone)) {
        Toast("没有输入手机号");
        return false;
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        Toast("请输入正确的手机号");
        return false;
      }
      if (isEmpty(this.password)) {
        Toast("请输入密码");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.btn-wrap {
  width: 100%;
  padding: 40px;
  margin-top: 100px;
  .title {
    text-align: center;
    font-size: 0.5rem;
    line-height: 3rem;
  }
  .reg-tip {
    text-align: right;
  }
}
.phone-wrap {
  border: 1px solid #eee;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
}
.code-wrap {
  display: flex;
  justify-content: space-between;
}

.ipt {
  font-size: 0.4rem;
  line-height: 50px;
  width: 100%;
  margin-left: 20px;
}
.code-con {
  border: 1px solid #eee;
  height: 100px;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  //   justify-content: center;
  align-items: center;
  padding-left: 30px;
}
.code {
  margin-left: 20px;
  height: 100px;
  width: 35%;
  border-radius: 10px;
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  line-height: 100px;
  background: #006feb;
}
.bg-blue {
  background: #006feb;
}
.btn {
  margin-top: 200px;
  width: 100%;
  height: 80px;
  background: #006feb;
  border-radius: 10px;
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  line-height: 80px;
}
.tips-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.color-tip {
  color: #888
}
</style>
